import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateImagingAssetUrlQueryVariables = Types.Exact<{
  input: Types.ImagingAssetUrlInput;
}>;


export type GenerateImagingAssetUrlQuery = { readonly __typename?: 'Query', readonly generateImagingAssetUrl: { readonly __typename?: 'ImagingAssetUrl', readonly url?: string | null } };


export const GenerateImagingAssetUrlDocument = gql`
    query GenerateImagingAssetUrl($input: ImagingAssetUrlInput!) {
  generateImagingAssetUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useGenerateImagingAssetUrlQuery__
 *
 * To run a query within a React component, call `useGenerateImagingAssetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateImagingAssetUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateImagingAssetUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateImagingAssetUrlQuery(baseOptions: Apollo.QueryHookOptions<GenerateImagingAssetUrlQuery, GenerateImagingAssetUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateImagingAssetUrlQuery, GenerateImagingAssetUrlQueryVariables>(GenerateImagingAssetUrlDocument, options);
      }
export function useGenerateImagingAssetUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateImagingAssetUrlQuery, GenerateImagingAssetUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateImagingAssetUrlQuery, GenerateImagingAssetUrlQueryVariables>(GenerateImagingAssetUrlDocument, options);
        }
export type GenerateImagingAssetUrlQueryHookResult = ReturnType<typeof useGenerateImagingAssetUrlQuery>;
export type GenerateImagingAssetUrlLazyQueryHookResult = ReturnType<typeof useGenerateImagingAssetUrlLazyQuery>;
export type GenerateImagingAssetUrlQueryResult = Apollo.QueryResult<GenerateImagingAssetUrlQuery, GenerateImagingAssetUrlQueryVariables>;